
(() => {
  const setup = () => document.querySelectorAll('[data-mv-blog-carousel]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const rail = root.querySelector('.mv-blog-carousel-rail');
    const cards = [...root.querySelectorAll('.mv-blog-carousel-card')];
    const dots = [...root.querySelectorAll('[data-blog-slide]')];
    if (!cards.length) return;
    let active = 0, pending = false;
    const go = index => {
      active = (index + cards.length) % cards.length;
      const left = cards[active].offsetLeft - cards[0].offsetLeft;
      rail.scrollTo({left, behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
    };
    const sync = () => {
      const step = cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : 1;
      active = Math.max(0,Math.min(cards.length-1,Math.round(rail.scrollLeft / step)));
      dots.forEach((dot,index) => dot.setAttribute('aria-pressed',String(index===active)));
      pending = false;
    };
    dots.forEach((dot,index) => dot.addEventListener('click',() => go(index)));
    rail.addEventListener('scroll',() => {
      if (!pending) {pending=true;requestAnimationFrame(sync);}
    },{passive:true});
    rail.addEventListener('keydown',event => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      go(active + (event.key === 'ArrowRight' ? 1 : -1));
    });
    sync();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',setup);
  else setup();
  document.addEventListener('shopify:section:load',setup);
})();
